<template>
  <section class="navigation-wrap">
    <nav-top
      class="nav-top"
    />
    <nav-menu-mobility
      v-if="isMenuVisible"
    />
    <section class="booking-header">
      <nav-booking-mobility
        v-if="isMenuVisible"
      />
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import NavTop from './NavTop'
import NavBookingMobility from './NavBookingMobility'
// import NavMenu from './NavMenu'
import NavMenuMobility from './NavMenuMobility'

export default {
  name: 'NavWrap',
  components: {
    NavTop,
    // NavMenu,
    NavMenuMobility,
    NavBookingMobility,
  },
  data() {
    return {
      isMenuVisible: true,
    }
  },
  computed: {
    ...mapState({
      stepping: (state) => state.stepping,
    }),
  },
  watch: {
    stepping: {
      handler() {
        this.setMenuVisiblity()
      },
      deep: true,
    },
  },
  created() {
    window.addEventListener('resize', this.setMenuVisiblity)
  },
  destroyed() {
    window.removeEventListener('resize', this.setMenuVisiblity)
  },
  methods: {
    setMenuVisiblity() {
      if (window.innerWidth <= 768) {
        this.isMenuVisible = true;
        return;
      }

      this.isMenuVisible = !this.stepping.currentStep;
    },
  },
}

</script>

<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

section {
  display: flex;
  flex-direction: column;
  left: 0;
  top: 0;
  width: 100%;

  @include teq-breakpoint($medium) {
    z-index: 9;
  }
}

.nav-top {
  @include teq-breakpoint($medium) {
    display: none;
    flex: 1;
  }
}

section div {
  display: flex;
  flex: 1;
  flex-direction: column;
  left: 0;
  top: 0;
  width: 100%;
}

.navigation-wrap {
  //background-color: $c-alto;
  background-color: white;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100vh;
  left: -90vw;
  position: fixed;
  width: calc(100vw - 6rem);

  @include teq-breakpoint($medium) {
    background-color: white;
    //border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    height: auto;
    left: 0;
    padding: 0 0;
    position: relative;
    // top: 64px;
    width: 100%;
  }

  .steps {
    display: flex;
  }
}

.booking-header {
  display: none;

  @include teq-breakpoint($medium) {
    display: flex;
  }
}
</style>
